import { render } from "./DashboardApp.vue?vue&type=template&id=03d7d19f&scoped=true"
import script from "./DashboardApp.vue?vue&type=script&lang=js"
export * from "./DashboardApp.vue?vue&type=script&lang=js"

import "./DashboardApp.vue?vue&type=style&index=0&id=03d7d19f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03d7d19f"]])

export default __exports__